import { TextMatchTransformer } from "@lexical/markdown";
import { $createTextNode, $getSelection, $isRangeSelection, LexicalNode, TextNode } from "lexical";
import { dataRequestToMarkdown, dataRequestTypes } from "../ai/autotext";
import { logDebug } from "../utils/log";
import { DCVariableNode } from "./DCVariableNode";

const variableRegExp = /\{\{([\w-]+(?:;[\w-]+=[^;{}]+)*)}\}/;

export const DCVariableTransformer: TextMatchTransformer = {
  type: "text-match",
  dependencies: [DCVariableNode],
  trigger: "}",

  regExp: variableRegExp,
  importRegExp: variableRegExp,

  export: (node: LexicalNode): string | null => {
    if (node instanceof DCVariableNode) {
      return dataRequestToMarkdown(node.dataRequest);
    } else {
      logDebug("not a dc-variable node: ", node);
      return null;
    }
  },

  replace: (textNode: TextNode, match: RegExpMatchArray) => {
    const [, name] = match;
    const canonicalName = name.split(";")[0];
    if (dataRequestTypes.includes(canonicalName)) {
      const variableNode = new DCVariableNode(name);
      textNode.replace(variableNode);
      const spacer = $createTextNode("\u200B");
      variableNode.insertAfter(spacer);
      const selection = $getSelection();
      if ($isRangeSelection(selection)) {
        selection.setTextNodeRange(spacer, 1, spacer, 1);
      }
    } else {
      logDebug(`Unsupported variable: ${name}`);
    }
  },
};
